$(() => {
    appendArrow();

    let winWidth = $(window).width();

    // hover functionality
    $('#nav li').on('mouseenter', function () {
        if (winWidth > 990) {
            $(this).children('.sub').next().show();
        }
    }).on('mouseleave', function () {
        if (winWidth > 990) {
            $(this).children('.sub').next().hide();
        }
    });

    // subnav arrow click
    $('.subnavArrow').on('click', function () {
        $(this).parent().siblings().find('ul').slideUp();
        $(this).next().next().slideToggle();
    });

    // window resize
    $(window).on('resize', function () {
        winWidth = $(window).width();
        if (winWidth > 990) {
            $('.navIcon').removeClass('navActive');
        } if (winWidth < 990) {
            $('.navBtn').removeClass('navActive');
            $('#nav').removeClass('active');
            $('#nav ul li ul').slideUp();
        }
    });

    $('.subnavArrow').on('click', function () {
        let navActive = $(this).hasClass('active');
        if (!navActive) {
            $(this).addClass('active');
        }
        if (navActive) {
            $(this).removeClass('active');
        }
    });

    // nav button click
    $('.navBtn').on('click', function () {
        let navActive = $('.navBtn').hasClass('navActive');
        if (!navActive) {
            $('.navBtn').addClass('navActive');
        }
        if (navActive) {
            $('.navBtn').removeClass('navActive');
        }
        if (!$('#nav').hasClass('active')) {
            $('#nav').addClass('active');
        } else {
            $('#nav').removeClass('active');
        }
    });

    // filter toggles
    const filterHandlers = [
        { trigger: '.colorTitle', box: '.colorBox', others: ['.priceBox', '.itemsBox'] },
        { trigger: '.priceTitle', box: '.priceBox', others: ['.colorBox', '.itemsBox'] },
        { trigger: '.itemsTitle', box: '.itemsBox', others: ['.colorBox', '.priceBox'] }
    ];

    filterHandlers.forEach(({ trigger, box, others }) => {
        $(trigger).on('click', function () {
            if (winWidth < 667) {
                filterActive($(this));
                others.forEach(sel => $(sel).slideUp());
                $(box).slideToggle();
            }
        });
    });

    // character counter init
    charsCounter();
});

// Commented the code for stopping this Ajax request to Disabled checkremarketingreload for case 4256
// page reload code that should not be run on checkout and thank-you page
if (WebPageObj.customerReview) {
    // Load external shopper approved script
    const js = document.createElement('script');
    js.src = 'https://www.shopperapproved.com/widgets/33789/merchant/review-page/02exC7bfMh5c.js';
    js.type = 'text/javascript';
    document.head.appendChild(js);

    // Toggle review form visibility
    $("#writeReview").on("click", () => {
        $('#avasReviewForm').toggleClass("hidden");
    });

    // Filters change handler
    $("#sortFilter, #ratingFilter").on("change", () => {
        loadReviews(1, true);
    });

    // Rating bar click → set filter
    $(".website-SA-review_bar").on("click", function () {
        const rating = $(this).data("rating");
        $("#ratingFilter").val(rating).trigger("change");
    });

    // Pagination click
    $("#site-pagination").on("click", "li.pageNumber", function () {
        const page = $(this).data("page");
        loadReviews(page, false);
    });

    // Next/Prev page handlers
    $(document).on("click", "#site-pagination > ul > li > span#nextPage", function () {
        const nextPageVal = $(this).attr("data-page");
        loadReviews(nextPageVal, false);
    });

    $(document).on("click", "#site-pagination > ul > li > span#prevPage", function () {
        const prevPageVal = $(this).attr("data-page");
        loadReviews(prevPageVal, false);
    });

    // Update pagination state
    function updatePagination(page) {
        const currentPage = parseInt(page, 10);
        $("#prevPage").attr("data-page", currentPage - 1);
        $("#nextPage").attr("data-page", currentPage + 1);

        $("#site-pagination li.active").removeClass("active");
        $(`#site-pagination li[data-page='${currentPage}']`).addClass("active");

        $("#site-pagination li span.site-pagination-prev")
            .toggleClass("hidden", currentPage === 1);

        const totalPages = parseInt($("#site-pagination li.pageNumber").last().data("page"), 10);
        $("#site-pagination li span.site-pagination-next")
            .toggleClass("hidden", currentPage === totalPages);
    }
    // Load reviews
    function loadReviews(page, reloadPagination) {
        const sortFilter = document.getElementById("sortFilter").value;
        const ratingFilter = document.getElementById("ratingFilter").value;
        $.ajax({
            url: '/ajax/loadMoreReviews',
            type: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            data: {
                sortFilter: sortFilter,
                ratingFilter: ratingFilter,
                page: page,
                reloadPagination: reloadPagination
            },
            success: function(response) {
                // Append the new reviews HTML to the container
                $("#loadMoreReviews").html(response.reviewsHtml);
                
                if (reloadPagination || response.paginationHtml) {
                    if (response.paginationHtml) {
                        if ($("#site-pagination").hasClass('hidden')) {
                            $("#site-pagination").removeClass('hidden');
                        }
                        $("#site-pagination").html(response.paginationHtml);
                    } else {
                        if (!$("#site-pagination").hasClass('hidden')) {
                            $("#site-pagination").addClass('hidden');
                        }
                    }
                }
                updatePagination(page);
            },
            error: function(error) {
                logError(error);
            }
        });

      
    }
}
